import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

import { PureRender } from 'utils/component-helpers';
import { responseValueToJsx } from 'containers/FormPage/FormResponseOverlay/responseValueToJsx';

const FormResponsesOverlay = ({
  toggleAction,
  formResponsesOverlayUser,
  formQuestions,
  formResponses,
}) => {
  const userResponse =
    formResponsesOverlayUser &&
    formResponses &&
    formResponses.find((item) => String(item.get('user')) === String(formResponsesOverlayUser.id));

  return formResponsesOverlayUser ? (
    <Dialog open onClose={() => toggleAction(null)} fullWidth maxWidth="md">
      <DialogTitle>{`${formResponsesOverlayUser.name}'s responses`}</DialogTitle>
      <DialogContent>
        {userResponse ? (
          formQuestions.map((question) => {
            const questionResponse = userResponse
              .get('data')
              .find((item) => String(item.get('question')) === String(question.get('_id')));
            if (!questionResponse) {
              return null;
            }
            const questionResponseValue = questionResponse.get('value');
            return (
              <Fragment key={question.get('_id')}>
                {question.get('questionType') !== 'Checkbox' ? (
                  <Typography
                    type="headline"
                    component="h3"
                    style={{ fontSize: 15, fontWeight: 500 }}
                  >
                    {question.get('title')}
                  </Typography>
                ) : null}
                <Typography component="p" style={{ fontSize: 15, fontWeight: 300 }}>
                  {question.get('questionType') === 'Checkbox' ? (
                    <CheckBoxIcon style={{ paddingRight: 5 }} />
                  ) : null}

                  {responseValueToJsx(questionResponseValue, question.get('questionType'))}
                </Typography>
                <br />
              </Fragment>
            );
          })
        ) : (
          <div>
            For some reason this user has not filled in any forms related to deed. Perhaps these
            forms were added after the user signed up?
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={() => toggleAction(null)}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  ) : null;
};

FormResponsesOverlay.propTypes = {
  formResponsesOverlayUser: PropTypes.object,
  formResponses: PropTypes.object,
  formQuestions: PropTypes.object,
  toggleAction: PropTypes.func,
};

export default PureRender(FormResponsesOverlay);
